module.exports = __webpack_public_path__ + "437f7d5297653d6acfc68278bab437b2.svg";